import { inject, injectable } from 'inversify';
import JsonRpcDispatcher, { interceptors } from '@dealroadshow/json-rpc-dispatcher';
import addSessionData from '@users/session/interceptors/rpc/addSessionData';
import checkSession from '@users/session/interceptors/rpc/checkSession';
import parseWrappedError from '@framework/api/Rpc/parseWrappedError';
import Container from '@framework/di/Container';
import type { ISocketDispatcher, ISocketAdapter } from './DI/interfaces';
import DITypes from './DI/types';

@injectable()
export class SocketDispatcher extends JsonRpcDispatcher implements ISocketDispatcher {
  constructor(
    @inject(DITypes.SocketAdapter) socketAdapter: ISocketAdapter,
    @inject(Container) container: Container,
  ) {
    super(socketAdapter);

    this.interceptRequest(addSessionData(container))
      .interceptResponse(checkSession(container))
      .interceptResponse(parseWrappedError())
      .interceptResponse(interceptors.response.transformErrorToException);
  }
}
